import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import CompsetSetupPage from "@/pages/CompsetSetupPage";
import { Toaster } from "@/components/ui/sonner";
import { APIProvider } from "@vis.gl/react-google-maps";
import { QueryClient, QueryClientProvider, useQueryClient } from "@tanstack/react-query";
import DashboardProvider from "./contexts/DashboardContext";
import CompsetProvider from "./contexts/CompsetContext";
import AuthProvider from "./contexts/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import OTPVerificationPage from "./pages/OtpVerificationPage";
import { IN_APP_ROUTES } from "./constants/urls";
import AuthGuard from "./components/auth/AuthGuard";
import PlanSelectionPage from "./pages/PlanSelectionPage";
import PlanRulesProvider from "./contexts/PlanRulesContext";
import AddCompsetPage from "./pages/AddCompsetPage";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import CreateCompsetPage from "./pages/CreateCompsetPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CancellationPage from "./pages/CancellationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ScrollToTop from "./components/ScrollToTop";
import { TooltipProvider } from "./components/ui/tooltip";



const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const OAUTH_ID = import.meta.env.VITE_GOOGLE_OAUTH_ID

function App() {

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
      }
    }
  });


  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <GoogleOAuthProvider clientId={OAUTH_ID} >
          <APIProvider apiKey={GOOGLE_API_KEY}>
            <TooltipProvider>
              <QueryClientProvider client={queryClient}>
                <AuthProvider>
                  <PlanRulesProvider>
                    <CompsetProvider>
                      <DashboardProvider>
                        <Routes>
                          <Route path="/" element={<LandingPage />} />
                          <Route path={IN_APP_ROUTES.LOGIN_PAGE} element={<LoginPage />} />
                          <Route path={IN_APP_ROUTES.REGISTER_PAGE} element={<RegisterPage />} />
                          <Route path={IN_APP_ROUTES.FORGOT_PASSWORD_PAGE} element={<ForgotPasswordPage />} />
                          <Route path={IN_APP_ROUTES.RESET_PASSWORD_PAGE} element={<ResetPasswordPage />} />
                          <Route path={IN_APP_ROUTES.OTP_VERIFICATION} element={<OTPVerificationPage />} />
                          <Route element={<AuthGuard />}>
                            <Route path={IN_APP_ROUTES.COMPSET_PAGE} element={<CompsetSetupPage />} />
                            <Route path={IN_APP_ROUTES.PAYMENT} element={<PlanSelectionPage />} />
                            <Route path={IN_APP_ROUTES.DASHBOARD} element={<DashboardPage />} />
                            <Route path={IN_APP_ROUTES.ADD_COMPSET} element={<AddCompsetPage />} />
                            <Route path={IN_APP_ROUTES.CREATE_COMPSET} element={<CreateCompsetPage />} />
                          </Route>
                          <Route path={IN_APP_ROUTES.PRIVACY_POLICY} element={<PrivacyPage />} />
                          <Route path={IN_APP_ROUTES.TERMS_AND_CONDITIONS} element={<TermsPage />} />
                          <Route path={IN_APP_ROUTES.CANCELLATION_POLICY} element={<CancellationPage />} />
                        </Routes>
                        <Toaster position="top-right" />
                      </DashboardProvider>
                    </CompsetProvider>
                  </PlanRulesProvider>
                </AuthProvider>
                {/* <ReactQueryDevtools /> */}
              </QueryClientProvider>
            </TooltipProvider>
          </APIProvider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
